import { Grid, Typography, Box } from '@mui/material';
import background from '../../../../assets/backroutes.png';

const Five = () => {
  return (
    <Box
      sx={{ 
        
        width: '100%',
        minHeight: { xs: '50vh', md: '100%' }, // Ocupa al menos la altura de la pantalla en móviles
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        marginTop: { xs: '0', md: '3%' }, // Sin margen superior en móviles
        padding: { xs: '20px', md: '0' }, // Agrega padding en móviles para que no quede pegado a los bordes
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255,255,255,0.1)',
          zIndex: 1,
        },
      }}
    >
      <Grid
        container
        spacing={{ xs: 3 }}
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          height: { xs: 'auto', md: '500px' }, // Ajusta la altura automáticamente en móviles
          padding: { xs: '20px', md: '0' }, // Padding en móviles para mejorar el espaciado
        }}
      >
        <Grid item xs={11} md={4} sx={{ marginTop:{xs:'70px'}, marginRight:{xs:'auto'}, margin:{md:'0 auto'}, textAlign: { xs: 'center', md: 'left' }, backgroundColor: 'rgba(255,255,255,0.6)', padding: { xs: '0', md: '0' } }}>
          <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', md: '3rem' }, fontWeight: 'bold' }}>
            Optimización de rutas
          </Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2, fontWeight: 'bold' }}>
            Reduce costos y tiempos con rutas inteligentes basadas en tráfico y condiciones viales.
          </Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2 }}>
            Optimiza tus rutas y reduce costos operativos con ahorros en combustible y mejoras en los tiempos de entrega.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Five;
